// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  Status,
} from './';

export default {
  path: 'status',
  name: 'Status',
  childRoutes: [
    { path: 'status', name: 'Status', component: Status, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/status/route.js